import CommentsPage from './CommentsPage'

export default CommentsPage
